import request from './index'

// 获取素材列表
export function getList(params) {
  return request({
    url: '/materials',
    method: 'get',
    params
  })
}

// 获取素材详情
export function getDetail(id) {
  return request({
    url: '/materials/' + id,
    method: 'get'
  })
}

// 保存素材（新增）
export function save(data) {
  return request({
    url: '/materials/save',
    method: 'post',
    data
  })
}

// 更新素材
export function update(id, data) {
  return request({
    url: '/materials/update/' + id,
    method: 'post',
    data
  })
}

// 删除素材
export function deleteMaterial(id) {
  return request({
    url: '/materials/delete/' + id,
    method: 'post'
  })
}

// 上传素材文件（大文件可能耗时较长，不设超时；支持 onUploadProgress / signal 用于进度条与中止上传）
export function upload(data, config = {}) {
  return request({
    url: '/materials/upload',
    method: 'post',
    data,
    timeout: 0,
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    ...config
  })
}
